import './App.css';
import {QueryClient, QueryClientProvider} from "react-query";
import {ReactQueryDevtools} from "react-query/devtools";
import Header from './components/Header';
import Banner from './components/Banner';
import Footer from './components/Footer';
import {atom, useAtom} from "jotai";
import LinkCard from "./views/LinkCard";

const queryClient = new QueryClient();

   function forceHTTPS() {
        const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        if (window.location.protocol === 'http:' && !isLocalhost) {
          window.location.href = window.location.href.replace('http:', 'https:');
        }
      } 
      
  

export const showBannerAtom = atom(true);

function App() {
    forceHTTPS()
    const [showBanner] = useAtom(showBannerAtom);
    return (
        <>
            <div className={`${!showBanner ? 'min-h-screen flex flex-col justify-between overflow-y-scroll' : ''}`}>
                <QueryClientProvider client={queryClient}>
                    <Header/>
                    <Banner/>
                    <div className={`App ${!showBanner ? 'h-[70%]' : ''}`}>
                        <LinkCard/>
                    </div>
                    <ReactQueryDevtools initialIsOpen={false}/>
                    <Footer/>
                </QueryClientProvider>
            </div>

        </>
    );
}

export default App;
